import { BlossomRenderer } from "./BlossomRenderer";
import { ModuleDefinition } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";
import { moduleDefinitionsMap } from "components/flexFramework/ModuleDefinitions/moduleDefinitionMap";

/**
 * Represents a Blossom Renderer derived from a Flex BFF Template data source.
 *
 * It should know how to render a list of Blossom Components who are also derived from the Template.
 */
export class BlossomRendererWithTemplate extends BlossomRenderer {
  public constructor(moduleDefinitions: ModuleDefinition[]) {
    const blossomComponents = BlossomComponentsFactory.get({ moduleDefinitions });
    super(moduleDefinitionsMap, blossomComponents);
  }
}
